<template>
  <div class="notfound-wrapper">
    <div class="notfound">
      <img src="/static/img/suez-white.png" class="logo">

      <h1>401</h1>
      <h4>Vous n'êtes pas autorisé à accéder à cette page</h4>

      <router-link class="btn btn-primary" to="/">Retour</router-link>

    </div>
  </div>
</template>
<script>
  export default {
    name: 'NotAuthorized',
  }
</script>

<style lang="scss">

@import '../scss/variables';


.notfound-wrapper {
  background-color:$suez-blue;
  display:flex;
  align-items: center;
  justify-content: center;
  height:100vh;
  color:white;

  .notfound {
    width:350px;
    text-align:center;

    .logo {
      max-width: 300px;
      padding:0;
      margin:0 auto;
      display:block;
      margin-bottom:3rem;
    }

    a {
      margin-top:3rem;
    }
  }
}


</style>



// WEBPACK FOOTER //
// 401.vue?68f508db